import {
  NOTE_CROP_BBOX_FIT,
  NOTE_CROP_CONTEXT_FACTOR,
  NOTE_CROP_MAX_REGION_PT,
  NOTE_CROP_MAX_UPSCALE,
  NOTE_CROP_MIN_REGION_PT,
} from "../appendNotePages/constants";
import type { ComputeCropRegion } from "./types";

const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

export const computeCropRegion: ComputeCropRegion = ({
  bbox,
  pdfPageWidth,
  pdfPageHeight,
  cropDisplayPx,
  sourcePxPerPt,
}) => {
  const bboxLongSide = Math.max(bbox.x2 - bbox.x1, bbox.y2 - bbox.y1, 0);

  let side = clamp(
    bboxLongSide * NOTE_CROP_CONTEXT_FACTOR,
    NOTE_CROP_MIN_REGION_PT,
    NOTE_CROP_MAX_REGION_PT,
  );
  side = Math.max(side, bboxLongSide * NOTE_CROP_BBOX_FIT);
  if (sourcePxPerPt > 0) {
    side = Math.max(
      side,
      cropDisplayPx / (sourcePxPerPt * NOTE_CROP_MAX_UPSCALE),
    );
  }
  side = Math.min(side, pdfPageWidth, pdfPageHeight);

  const centerX = (bbox.x1 + bbox.x2) / 2;
  const centerY = (bbox.y1 + bbox.y2) / 2;

  return {
    x: clamp(centerX - side / 2, 0, pdfPageWidth - side),
    y: clamp(centerY - side / 2, 0, pdfPageHeight - side),
    side,
  };
};
